import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { connect } from 'react-redux';
import { AppState } from '../../../store';
import { updateUserSettings } from '../../../store/user/actions';

const ColumnToggleList: React.FC<any> = (props: any) => {
    const { columns, onColumnToggle, toggles, ignore, target, UserSettings, updateUserSettings } = props;
    const handleClick = (e: React.SyntheticEvent, dataField: string) => {
        //console.log(dataField, target, toggles)
        if (target) {
            let t: any = { ...toggles };
            t[dataField] = !t[dataField];
            let newHidden: Array<string> = Object.keys(t).filter((df: string) => !t[df]);
            //console.log("New Hidden: ", newHidden);
            updateUserSettings({ ...UserSettings, [target]: newHidden });
        } else {
            onColumnToggle(dataField);
        }
    }

    React.useEffect(() => {
        //console.log("RERENDERING COLUMN TOGGLE: ", toggles, columns, ignore);
        //r-18-lint-dj
        //eslint-disable-next-line
    }, [props])

    return (
        <Dropdown style={{ marginBottom: -24, marginRight: 1 }}>
            <Dropdown.Toggle as="div" className="action-text remove-dropdown-arrow ml-auto d-flex flex-row align-items-center justify-content-center" style={{ height: 20, width: 50 }}>
                <i className="material-icons" style={{ fontSize: 18 }}>visibility</i>
                <span className="font-weight-bold" style={{ fontSize: 14 }}>
                    {Object.values(toggles).reduce((acc: number, cur: any) => (cur ? acc + 1 : acc), 0) - ignore.length}
                    /{columns.length - ignore.length}
                </span>
            </Dropdown.Toggle>
            <Dropdown.Menu>
                {(ignore && toggles !== null)
                    ?
                    columns.filter((column: any) => !ignore.includes(column.dataField)).map((column: any, index: number) => (
                        <div key={index} onClick={e => handleClick(e, column.dataField)} className="d-flex flex-row align-items-center action-text py-1 px-2">
                            <i className="material-icons">{toggles[column.dataField] ? "check_box" : "check_box_outline_blank"}</i>
                            <span style={{ marginLeft: 20 }}>{column.text}</span>
                        </div>
                    ))
                    :
                    columns.map((column: any, index: number) => (
                        <div key={index} onClick={e => handleClick(e, column.dataField)} className="d-flex flex-row align-items-center action-text py-1 px-2">
                            <i className="material-icons">{toggles[column.dataField] ? "check_box" : "check_box_outline_blank"}</i>
                            <span style={{ marginLeft: 20 }}>{column.text}</span>
                        </div>
                    ))
                }
            </Dropdown.Menu>
        </Dropdown>
    )
}

const mapStateToProps = (state: AppState) => ({
    UserSettings: state.user.UserSettings
})

export default connect(mapStateToProps, { updateUserSettings })(ColumnToggleList);